import { type AggregationFn } from "@tanstack/react-table";

import { round } from "./aggregationFnUtils";

/**
 * NOTE: This function is called `unique` because we want it to show up as `unique` in the DataGrid
 * UI, and that is determined by the `name` field of the function.
 */
export const unique: AggregationFn<unknown> = (columnId, leafRows) => {
	const seen = new Set();
	let uniqueCount = 0;
	let totalCount = 0;
	leafRows.forEach((row) => {
		const value = row.getValue(columnId);
		totalCount += 1;
		if (value !== undefined && value !== "" && value !== null && !seen.has(value)) {
			seen.add(value);
			uniqueCount += 1;
		}
	});

	if (totalCount === 0 || uniqueCount === 0) {
		return "0%";
	}

	return `${round((uniqueCount / totalCount) * 100)}%`;
};
